import React from 'react'
import SavingImg1 from '../../Images/SavingImg/DailySaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const DailySaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>दैनिक बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>संस्थाका सदस्यहरूले दैनिक रूपमा बचत जम्मा गर्नुपर्ने । </li>
                                        <li>घर दैलोमा गई बचत संकलन गरिने । </li>
                                        <li>निशुल्कः भुक्तानी पुर्जा उपलब्ध गराईने ।</li>
                                        <li>स्वेच्छिक रूपमा खाता बन्द गर्न सकिने । खाताबन्दी शुल्क रु. ५० लाग्ने ।</li>
                                        <li>ब्याजलाई संरक्षित पूँजी फिर्ता कोष वितरणमा गणना गरिने । </li>
                                        <li>उत्कृष्ट बचत कर्तालाई पुरस्कार तथा सम्मान प्रदान गरिने ।</li>
                                        <li>खातामा न्युनतम मौज्दात रु २००।– राखि बाँकी फिर्ता लान सकिनेछ ।</li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default DailySaving